import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastService } from '@siemens/ix-angular';
import { Project } from '../models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private readonly projectsSubject = new BehaviorSubject<Project[]>([]);
  readonly projects$ = this.projectsSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly toastService: ToastService
  ) {}

  public getProjects(): void {
    this.http.get<Project[]>(`${environment.baseUrl}/projects`).subscribe({
      next: projects => {
        this.projectsSubject.next(projects);
      },
      error: err => {
        const details = err.message || '';
        this.toastService.show({
          title: 'Projects error',
          message: 'We cannot load the projects from the server. ' + details,
          type: 'error'
        });
      }
    });
  }

  public getProject(id: number) {
    return this.http.get<Project>(`${environment.baseUrl}/projects/${id}`);
  }

  public createProject(project = {}) {
    this.http.post<Project>(`${environment.baseUrl}/calculation-file/create`, project).subscribe({
      next: projectFromDatabase => {
        const currentProject = this.projectsSubject.getValue();
        const updatedProjects = [...currentProject, projectFromDatabase];
        this.projectsSubject.next(updatedProjects);
      },
      error: err => {
        const details = err.message || '';
        this.toastService.show({
          title: 'Create project error',
          message: 'We cannot create the project. Try again. ' + details,
          type: 'error'
        });
      }
    });
  }

  public deleteProject(id: number): void {
    this.http.delete<void>(`${environment.baseUrl}/projects/${id}`).subscribe({
      next: () => {
        const currentProjects = this.projectsSubject.getValue();
        this.projectsSubject.next(currentProjects.filter(item => item.id !== id));
      },
      error: err => {
        const details = err.message || '';
        this.toastService.show({
          title: 'Delete project error',
          message: 'We cannot delete the project. Try again. ' + details,
          type: 'error'
        });
      }
    });
  }

  public updateProject(id: number, updatedProject = {}) {
    this.http.patch<Project>(`${environment.baseUrl}/projects/${id}`, updatedProject).subscribe({
      next: project => {
        const currentProjects = this.projectsSubject.getValue();
        this.projectsSubject.next(currentProjects.map(item => (item.id === id ? project : item)));
      },
      error: err => {
        const details = err.message || '';
        this.toastService.show({
          title: 'Update project error',
          message: 'We cannot update the project. Try again. ' + details,
          type: 'error'
        });
      }
    });
  }
}
